import React from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
//import GetAllFormFields from '../../../../components/_utils/formUtils'
import { Card, Col, Form, Row, Button, notification, Icon, Badge, Descriptions, Tag, Avatar, Tooltip } from 'antd'
import './studentStyleDesign.css'
import Request, { MEDIA_URL } from '../../../request'
import { connect } from 'react-redux'
import moment from 'moment'
import { Link } from 'react-router-dom'
import Exception from '../../../components/Exception'
import userRights from "../../../components/_utils/userRights";
import { RightsWrapper } from '../../../components/_utils/utils'
import ReceiptView from '../../../components/DocumentViews/receiptView'
import { FaDownload } from 'react-icons/fa'

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const showChannelPartner = userRights.getUserAuth('showChannelPartner');

const styles = {
    th: {
        padding: '12px 15px',
        textAlign: 'left',
        color: '#8c8c8c',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        fontWeight: 600
    },
    td: {
        padding: '12px 15px',
        fontSize: '13px',
        color: '#262626',
        verticalAlign: 'top'
    },
    dateRow: {
        fontSize: '11px',
        lineHeight: '1.8',
        whiteSpace: 'nowrap'
    },
    dateLabel: {
        color: '#8c8c8c',
        marginRight: '5px',
        display: 'inline-block',
        width: '60px'
    },
    label: {
        color: '#8c8c8c',
        minWidth: '140px',
        display: 'inline-block',
        fontSize: '12px'
    }
};

@Form.create()
class ProfileDetails extends React.Component {
    state = {
        profileDetails: null,
        allow: true,
        studentId: null,
        showAccountPaymentDrawar: false,
        recordId: null,
        claimDeskRights: {}
    }

    async componentWillMount() {
        let searchParams = new URLSearchParams(this.props.search)

        let studentId = searchParams.get('id')

        if (studentId) {
            let data = await Request.getInquiry(studentId)
            this.setState({ profileDetails: data.doc, allow: data.allow, studentId: studentId })
        }

    }

    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        this.setState({ claimDeskRights: userRights.ClaimDesk })
    }


    componentDidMount() {
        this.loadUserRights();
    }




    showPaymentDrawer = async (receiptNumber) => {
        const response = await Request.getAccountPaymentDetailByReceipt({ id: receiptNumber });
        if (response && response.success) {
            this.setState({
                showAccountPaymentDrawar: true,
                recordId: response.doc._id
            });
        } else {
            notification.error({
                message: 'Receipt Not Found'
            })
        }
    }

    closeDocument = () => {
        this.setState({ showAccountPaymentDrawar: false });
    }

    render() {

        function formatAmount(amount, currency) {
            if (amount === null || amount === undefined) {
                return "NA";
            }
            return currency ? currency + " " + amount : amount;
        }

        // const {
        //     form: {getFieldDecorator, getFieldValue}
        // } = this.props

        const { profileDetails = null, allow, showAccountPaymentDrawar, recordId, claimDeskRights } = this.state
        return (!allow ? <Exception
            type="404"
            desc={'No Access'}
            linkElement={Link}
            redirect={'/dashboard'}
            backText={'Go To Homepage?'}
        /> :

            <PageHeaderWrapper>
                {
                    showAccountPaymentDrawar ?
                        <ReceiptView recordId={recordId} onClose={this.closeDocument} />
                        : null
                }
                <Card>
                    {
                        this.state && this.state.profileDetails &&
                        <div>
                            <Row gutter={16}>
                                {/* Image and Basic Details Column */}
                                <Col span={8}>
                                    <Card
                                        bordered={false}
                                        className='cardStyle'
                                        style={{ borderRadius: '8px', height: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}

                                    >
                                        <div style={{ position: 'absolute', top: '1px', right: '5px', zIndex: 10 }}>
                                            <Tooltip title="Edit Profile">
                                                <Button
                                                    type="link"
                                                    icon="edit"
                                                    size='small'
                                                    onClick={() => { window.location.href = `update?id=${this.state.studentId}&tab=1`; }}
                                                    style={{ padding: 0, color: '#1890ff' }}
                                                />
                                            </Tooltip>
                                        </div>
                                        {/* Profile Image Section */}
                                        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                                            {
                                                profileDetails &&
                                                    profileDetails.profilePic &&
                                                    profileDetails.profilePic.length > 0 ? (
                                                    <Avatar
                                                        size={120}
                                                        src={profileDetails.profilePic[0].url}
                                                        style={{ border: '3px solid #f0f2f5' }}
                                                    />
                                                ) : (
                                                    <Avatar
                                                        size={120}
                                                        src="https://bootdey.com/img/Content/avatar/avatar7.png"
                                                        style={{ border: '3px solid #f0f2f5' }}
                                                    />
                                                )
                                            }
                                            <h2 style={{ marginTop: '16px', marginBottom: '4px' }}>{profileDetails.studentName}</h2>
                                            <Tag color="blue">{profileDetails.id}</Tag>
                                            {
                                                profileDetails && profileDetails.atLevel === "Front Desk" && profileDetails.lead_status_detail && profileDetails.lead_status_detail.statusName && (
                                                    <h4 style={{ marginTop: '16px', marginBottom: '4px' }}>{profileDetails && profileDetails.lead_status_detail && profileDetails.lead_status_detail.statusName}</h4>
                                                )
                                            }
                                        </div>

                                        {/* Information List */}
                                        <Descriptions column={1} size="small" bordered={false} layout="horizontal">
                                            <Descriptions.Item
                                                label={
                                                    <span>
                                                        <Icon type="calendar" style={{ marginRight: 8 }} />
                                                        Created Date
                                                    </span>
                                                }
                                            >
                                                {profileDetails.createdByUser && profileDetails.createdByUser.time
                                                    ? moment(profileDetails.createdByUser.time).format("DD.MM.YYYY h:mm A")
                                                    : "NA"}
                                            </Descriptions.Item>
                                            <Descriptions.Item label={<span><Icon type="man" style={{ marginRight: 8 }} />Gender</span>}>
                                                {profileDetails.gender}
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="phone" style={{ marginRight: 8 }} />Mobile</span>}>
                                                {profileDetails.countryCode} {profileDetails.mobile}
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="phone" style={{ marginRight: 8 }} />WhatsApp</span>}>
                                                {profileDetails.countryCode} {profileDetails.watsupp ? profileDetails.watsupp : profileDetails.mobile}
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="mail" style={{ marginRight: 8 }} />Email</span>}>
                                                <span style={{ wordBreak: 'break-all' }}>{profileDetails.emailId}</span>
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="calendar" style={{ marginRight: 8 }} />D.O.B</span>}>
                                                {moment(profileDetails.dateOfBirth).format('DD MMM YYYY')}
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="solution" style={{ marginRight: 8 }} />Marital</span>}>
                                                {profileDetails.maritalStatus}
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="environment" style={{ marginRight: 8 }} />Address</span>}>
                                                {profileDetails.profile && profileDetails.profile.address}
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="info-circle" style={{ marginRight: 8 }} />Source</span>}>
                                                <Tag color="cyan" style={{ marginRight: 0 }}>
                                                    {profileDetails.location}
                                                </Tag>
                                                {profileDetails.associatePartnerName && (
                                                    <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px' }}>
                                                        ({profileDetails.associatePartnerName})
                                                    </div>
                                                )}
                                            </Descriptions.Item>

                                            <Descriptions.Item label={<span><Icon type="desktop" style={{ marginRight: 8 }} />Desk</span>}>
                                                <Badge status="processing" text={profileDetails.atLevel === "Front Desk" ? "Counselling Desk" : profileDetails.atLevel} />
                                            </Descriptions.Item>
                                        </Descriptions>
                                    </Card>
                                </Col>
                                {/* First Row Second Column */}
                                <Col span={16}>
                                    {/* Aboard & Preference Column */}
                                    <Col span={12}>
                                        <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: "#fff" }}>Abroad Information</span>
                                            <a
                                                href={`update?id=${this.state.studentId}&tab=2`}
                                                target="_blank"
                                                style={{
                                                    // backgroundColor: "transparent",
                                                    // border: "1px solid white", // White border
                                                    color: "#fff", // White text
                                                    position: "absolute",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textDecoration: "underline",
                                                    fontSize: "12px",
                                                    right: 0, // Pushes button to the right
                                                }}>Edit</a></div>} bordered={false} className='cardStyle'>
                                            <Descriptions column={1} size="small" colon={false} layout="horizontal">
                                                <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>Year of Planning</span>}>
                                                    <Tag color="blue" style={{ fontWeight: 600 }}>{profileDetails.whichYearPlanningToGo}</Tag>
                                                </Descriptions.Item>

                                                <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>Study Level</span>}>
                                                    {profileDetails.enqType}
                                                </Descriptions.Item>

                                                <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>Counsellor</span>}>
                                                    <span style={{ fontWeight: 500 }}>
                                                        {profileDetails.counsellorId && profileDetails.counsellorId.name ? profileDetails.counsellorId.name : 'Not Assigned'}
                                                    </span>
                                                </Descriptions.Item>

                                                <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>English Test</span>}>
                                                    <Badge
                                                        status={profileDetails.haveEnglishTestScore === "Yes" ? "success" : "default"}
                                                        text={profileDetails.haveEnglishTestScore}
                                                    />
                                                </Descriptions.Item>
                                            </Descriptions>

                                            {profileDetails.haveEnglishTestScore === "Yes" && (
                                                <div style={{ marginTop: '16px', padding: '12px', background: '#fafafa', borderRadius: '4px', border: '1px solid #f0f0f0' }}>
                                                    <div style={{ marginBottom: '10px', borderBottom: '1px solid #e8e8e8', paddingBottom: '4px' }}>
                                                        <b style={{ color: '#262626' }}>{profileDetails.testType} Performance</b>
                                                    </div>

                                                    <Row gutter={[8, 8]}>
                                                        <Col span={12}>
                                                            <small style={{ color: '#8c8c8c' }}>Overall Score</small>
                                                            <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#1890ff' }}>
                                                                {profileDetails.profile && profileDetails.profile.overAllScore ? profileDetails.profile.overAllScore : 'N/A'}
                                                            </div>
                                                        </Col>
                                                        <Col span={12}>
                                                            {/* Simple grid for modules */}
                                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px', fontSize: '11px' }}>
                                                                <div>R: <b>{profileDetails.profile && profileDetails.profile.reading ? profileDetails.profile.reading : '-'}</b></div>
                                                                <div>W: <b>{profileDetails.profile && profileDetails.profile.writing ? profileDetails.profile.writing : '-'}</b></div>
                                                                <div>L: <b>{profileDetails.profile && profileDetails.profile.listening ? profileDetails.profile.listening : '-'}</b></div>
                                                                <div>S: <b>{profileDetails.profile && profileDetails.profile.speaking ? profileDetails.profile.speaking : '-'}</b></div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )}
                                        </Card>

                                    </Col>
                                    <Col span={12}>
                                        <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: '#fff' }}>Preferences</span><a
                                            href={`update?id=${this.state.studentId}&tab=3`}
                                            target="_blank"
                                            style={{
                                                // backgroundColor: "transparent",
                                                // border: "1px solid white", // White border
                                                color: "#fff", // White text
                                                position: "absolute",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textDecoration: "underline",
                                                fontSize: "12px",
                                                right: 0, // Pushes button to the right
                                            }}>Edit</a></div>} bordered={false} className='cardStyle'>
                                            {profileDetails.totalPreference && profileDetails.totalPreference.length > 0 ? (
                                                <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                                                    {profileDetails.totalPreference.map((preference, index) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                padding: '8px 12px',
                                                                marginBottom: '8px',
                                                                background: '#fafafa',
                                                                borderRadius: '4px',
                                                                borderLeft: '3px solid #1890ff'
                                                            }}
                                                        >
                                                            <div>
                                                                <small style={{ color: '#8c8c8c', display: 'block', fontSize: '10px', textTransform: 'uppercase' }}>Country</small>
                                                                <span style={{ fontWeight: 600, color: '#262626' }}>{preference.country}</span>
                                                            </div>
                                                            <div style={{ textAlign: 'right' }}>
                                                                <small style={{ color: '#8c8c8c', display: 'block', fontSize: '10px', textTransform: 'uppercase' }}>City</small>
                                                                <Tag color="blue" style={{ marginRight: 0 }}>{preference.city}</Tag>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '20px', color: '#bfbfbf' }}>
                                                    <Icon type="info-circle" style={{ marginRight: 4 }} /> No preferences set
                                                </div>
                                            )}
                                        </Card>
                                        <Card style={{ marginTop: 10 }} title={<span style={{ color: "#fff" }}>Passport Details</span>} bordered={false} className='cardStyle'>
                                            {profileDetails.visaDesk && profileDetails.visaDesk.passportNo ? (
                                                <Descriptions
                                                    column={1}
                                                    size="small"
                                                    bordered={false}
                                                    colon={true}
                                                    layout="horizontal"
                                                >
                                                    <Descriptions.Item label={<b>Passport Number</b>}>
                                                        <span style={{ color: '#1890ff', fontWeight: 600 }}>
                                                            {profileDetails.visaDesk.passportNo}
                                                        </span>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<b>Issue Date</b>}>
                                                        {moment(profileDetails.issueDate).format('DD MMM YYYY')}
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<b>Expiry Date</b>}>
                                                        <span style={{
                                                            color: moment(profileDetails.expiryDate).isBefore(moment()) ? '#f5222d' : 'inherit'
                                                        }}>
                                                            {moment(profileDetails.expiryDate).format('DD MMM YYYY')}
                                                        </span>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<b>Issue Country</b>}>
                                                        <Tag color="blue" style={{ borderRadius: '10px' }}>
                                                            {profileDetails.issueCountryName}
                                                        </Tag>
                                                    </Descriptions.Item>
                                                </Descriptions>
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '20px', color: '#bfbfbf' }}>
                                                    <Icon type="info-circle" style={{ marginRight: 4 }} /> No Passport Details Available
                                                </div>
                                            )}
                                        </Card>
                                    </Col>
                                    {/* Qualification Column */}
                                    <Col span={24}>
                                        <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: '#fff' }}>Qualifications</span><a
                                            href={`update?id=${this.state.studentId}&tab=4`}
                                            target="_blank"
                                            style={{
                                                color: "#fff", // White text
                                                position: "absolute",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textDecoration: "underline",
                                                fontSize: "12px",
                                                right: 0, // Pushes button to the right
                                            }}>Edit</a></div>} bordered={false} className='cardStyle' style={{ marginTop: '20px' }}>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0' }}>
                                                            <th style={styles.th}>Qualification</th>
                                                            <th style={styles.th}>Passing Year</th>
                                                            <th style={styles.th}>Stream</th>
                                                            <th style={styles.th}>Score Details</th>
                                                            <th style={styles.th}>Board / University</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {profileDetails.profile && profileDetails.profile.newQualification && profileDetails.profile.newQualification.length > 0 ? (
                                                            profileDetails.profile.newQualification.map((qual, index) => {
                                                                // Safe stream handling
                                                                let streamDisplay = "";
                                                                if (qual && qual.stream) {
                                                                    streamDisplay = Array.isArray(qual.stream) ? qual.stream.join(", ") : qual.stream;
                                                                }

                                                                return (
                                                                    <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                                        <td style={styles.td}>
                                                                            <div style={{ fontWeight: 'bold', color: '#1890ff' }}>{qual.qualification}</div>
                                                                        </td>
                                                                        <td style={styles.td}>
                                                                            {qual.to ? moment(qual.to, "MM-YYYY").format("MMM YYYY") : ""}
                                                                        </td>
                                                                        <td style={styles.td}>
                                                                            <div style={{ fontSize: '12px', color: '#595959' }}>{streamDisplay}</div>
                                                                        </td>
                                                                        <td style={styles.td}>
                                                                            <Tag color="green" style={{ fontWeight: 600 }}>
                                                                                {qual.score} {qual.gradingSystem ? `(${qual.gradingSystem})` : ""}
                                                                            </Tag>
                                                                        </td>
                                                                        <td style={styles.td}>
                                                                            <div style={{ fontWeight: 500 }}>{qual.university}</div>
                                                                            <div style={{ fontSize: '11px', color: '#8c8c8c' }}>{qual.board}</div>
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" style={{ padding: '30px', textAlign: 'center', color: '#bfbfbf' }}>
                                                                    <Icon type="info-circle" style={{ marginRight: 8 }} />
                                                                    No qualification details found.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Card>
                                    </Col>
                                </Col>


                            </Row>
                            {/* Counsellor Desk Table */}
                            <Card title={<span style={{ color: "#fff" }}>Counselling Information</span>} className='mainCardStyle'>
                                <Row gutter={16}>
                                    {/* Current and Rating History Section */}
                                    <Col span={8}>
                                        {/* Rating Table */}
                                        <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: '#fff' }}>Rating <RightsWrapper myRight={"FrontDesk.view"}><a
                                            href={`/desk/update-counselling?id=${this.state.studentId}&tab=1`}
                                            target="_blank"
                                            style={{
                                                color: "#fff", // White text
                                                position: "absolute",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                textDecoration: "underline",
                                                fontSize: "12px",
                                                right: 0, // Pushes button to the right
                                            }}>Edit</a></RightsWrapper></span></div>} bordered={false} className='cardStyle'>
                                            <Descriptions column={1} size="small" colon={false} layout="horizontal">
                                                <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>Quality Rating</span>}>
                                                    <Tag color="orange" style={{ fontWeight: 600 }}>
                                                        {profileDetails.counsellingDesk && profileDetails.counsellingDesk.qualityRating ? profileDetails.counsellingDesk.qualityRating : 'N/A'}
                                                    </Tag>
                                                </Descriptions.Item>
                                                <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>Conversion Rating</span>}>
                                                    <Tag color="orange" style={{ fontWeight: 600 }}>
                                                        {profileDetails.counsellingDesk && profileDetails.counsellingDesk.ratingName ? profileDetails.counsellingDesk.ratingName : 'N/A'}
                                                    </Tag>
                                                </Descriptions.Item>

                                                <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>Rating Tag</span>}>
                                                    <span style={{ color: '#262626', fontWeight: 500 }}>
                                                        {profileDetails.counsellingDesk && profileDetails.counsellingDesk.subRatingName ? profileDetails.counsellingDesk.subRatingName : 'None'}
                                                    </span>
                                                </Descriptions.Item>

                                                {/* <Descriptions.Item label={<span style={{ color: '#8c8c8c' }}>Marital Status</span>}>
                                                    <Badge
                                                        status="default"
                                                        text={profileDetails.counsellingDesk && profileDetails.counsellingDesk.maritalStatus ? profileDetails.counsellingDesk.maritalStatus : 'Unknown'}
                                                    />
                                                </Descriptions.Item> */}
                                            </Descriptions>
                                        </Card>
                                    </Col>
                                    <Col span={16}>
                                        <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: "#fff" }}>Courses</span>
                                            <RightsWrapper myRight={"FrontDesk.view"}><a
                                                href={`/desk/update-counselling?id=${this.state.studentId}&tab=2`}
                                                target="_blank"
                                                style={{
                                                    color: "#fff", // White text
                                                    position: "absolute",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    textDecoration: "underline",
                                                    fontSize: "12px",
                                                    right: 0, // Pushes button to the right
                                                }}>Edit</a></RightsWrapper>
                                        </div>} bordered={false} className='cardStyle'>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0' }}>
                                                            <th style={styles.th}>Course & University</th>
                                                            <th style={styles.th}>Campus</th>
                                                            <th style={styles.th}>Pathway</th>
                                                            <th style={styles.th}>Fees / Duration</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {profileDetails.counsellingDesk && profileDetails.counsellingDesk.course && profileDetails.counsellingDesk.course.length > 0 ? (
                                                            profileDetails.counsellingDesk.course.map((cours, index) => (
                                                                <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                                    <td style={styles.td}>
                                                                        <div style={{ fontWeight: 'bold', color: '#262626' }}>{cours.courseName}</div>
                                                                        <div style={{ fontSize: '11px', color: '#8c8c8c' }}>{cours.universityInstitutionName}</div>
                                                                    </td>
                                                                    <td style={styles.td}>
                                                                        <Tag color="blue" style={{ borderRadius: '10px', fontSize: '11px' }}>
                                                                            {cours.campusName ? cours.campusName : 'Main Campus'}
                                                                        </Tag>
                                                                    </td>
                                                                    <td style={styles.td}>
                                                                        <span style={{ fontSize: '12px' }}>{cours.pathWay ? cours.pathWay : 'Direct'}</span>
                                                                    </td>
                                                                    <td style={styles.td}>
                                                                        <div style={{ fontWeight: 600, color: '#52c41a' }}>{cours.tutionFee}</div>
                                                                        <div style={{ fontSize: '11px', color: '#bfbfbf' }}>Duration: {cours.courseDuration}</div>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="4" style={{ padding: '30px', textAlign: 'center', color: '#bfbfbf' }}>
                                                                    <Icon type="info-circle" style={{ marginRight: 8 }} />
                                                                    No courses shortlisted.
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                        </Card>
                                    </Col>
                                </Row>
                            </Card>
                            <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: "#fff" }}>Application Information </span>
                                <RightsWrapper myRight={"ApplicationDesk.view"}><a
                                    href={`/desk/allApplication-desk/update?id=${this.state.studentId}`}
                                    target="_blank"
                                    style={{
                                        color: "#fff", // White text
                                        position: "absolute",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        textDecoration: "underline",
                                        fontSize: "12px",
                                        right: 0, // Pushes button to the right
                                    }}>Edit</a>
                                </RightsWrapper>
                            </div>} className='mainCardStyle'>
                                <div style={{ overflowX: 'auto' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                        <thead>
                                            <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0' }}>
                                                <th style={styles.th}>Student & Intake</th>
                                                <th style={styles.th}>Course & University</th>
                                                <th style={styles.th}>Application Status</th>
                                                <th style={styles.th}>Timeline (Exp/Proc)</th>
                                                <th style={styles.th}>Course Schedule</th>
                                                <th style={styles.th}>Offer Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {profileDetails.applicationsDesk && profileDetails.applicationsDesk.course && profileDetails.applicationsDesk.course.length > 0 ? (
                                                profileDetails.applicationsDesk.course.map((cours, index) => {
                                                    // Safe Status Check
                                                    const statusList = cours.applicationStatus;
                                                    const currentAppStatus = (statusList && statusList.length > 0)
                                                        ? statusList[statusList.length - 1].status
                                                        : 'N/A';

                                                    return (
                                                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                            {/* Student ID & Intake */}
                                                            <td style={styles.td}>
                                                                <div style={{ fontWeight: 'bold', color: '#1890ff' }}>{cours.stage2 && cours.stage2.instituteStudentId}</div>
                                                                <div style={{ fontSize: '11px', color: '#8c8c8c', marginTop: '4px' }}>
                                                                    <Icon type="calendar" /> {cours.intake}-{cours.intakeYear}
                                                                </div>
                                                            </td>

                                                            {/* Course/University */}
                                                            <td style={styles.td}>
                                                                <div style={{ fontWeight: 600, color: '#262626' }}>{cours.courseName}</div>
                                                                <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{cours.universityInstitutionName}</div>
                                                            </td>

                                                            {/* Application Status */}
                                                            <td style={styles.td}>
                                                                <Tag color="blue" style={{ borderRadius: '4px' }}>{currentAppStatus}</Tag>
                                                            </td>

                                                            {/* Timeline */}
                                                            <td style={styles.td}>
                                                                <div style={styles.dateRow}>
                                                                    <span style={styles.dateLabel}>Expected:</span>
                                                                    {cours.stage2 && cours.stage2.offerExpDate ? moment(cours.stage2.offerExpDate).format('DD MMM YYYY') : 'N/A'}
                                                                </div>
                                                                <div style={styles.dateRow}>
                                                                    <span style={styles.dateLabel}>Processed:</span>
                                                                    {cours.processedDate ? moment(cours.processedDate).format('DD MMM YYYY') : 'N/A'}
                                                                </div>
                                                            </td>

                                                            {/* Course Schedule */}
                                                            <td style={styles.td}>
                                                                <div style={styles.dateRow}>
                                                                    <span style={styles.dateLabel}>Start:</span>
                                                                    {cours.stage2 && cours.stage2.courseStartDate ? moment(cours.stage2.courseStartDate).format('DD MMM YYYY') : 'N/A'}
                                                                </div>
                                                                <div style={styles.dateRow}>
                                                                    <span style={styles.dateLabel}>Fee Due:</span>
                                                                    <span style={{ color: '#f5222d' }}>
                                                                        {cours.stage2 && cours.stage2.feeDueDate ? moment(cours.stage2.feeDueDate).format('DD MMM YYYY') : 'N/A'}
                                                                    </span>
                                                                </div>
                                                            </td>

                                                            {/* Final Offer Status */}
                                                            <td style={styles.td}>
                                                                <Tag
                                                                    color={cours.stage2 && cours.stage2.offerStatus === 'Approved' ? 'green' : 'orange'}
                                                                    style={{ fontWeight: 600 }}
                                                                >
                                                                    {cours.stage2 && cours.stage2.offerStatus ? cours.stage2.offerStatus : 'Pending'}
                                                                </Tag>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="6" style={{ padding: '40px', textAlign: 'center', color: '#bfbfbf' }}>
                                                        <Icon type="info-circle" style={{ fontSize: '24px', marginBottom: '8px' }} /><br />
                                                        No application records found.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </Card>

                            {/* Application Desk */}
                            <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: '#fff' }}>Visa Information </span><RightsWrapper myRight={"VisaDesk.view"}><a
                                href={`/desk/getVisa?id=${this.state.studentId}`}
                                target="_blank"
                                style={{
                                    // backgroundColor: "transparent",
                                    // border: "1px solid white", // White border
                                    color: "#fff", // White text
                                    position: "absolute",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textDecoration: "underline",
                                    fontSize: "12px",
                                    right: 0, // Pushes button to the right
                                }}>Edit</a></RightsWrapper></div>} className='mainCardStyle'>
                                <Row gutter={16}>

                                    <Col span={12}>
                                        {/* Visa Details Table */}
                                        <Card title={<span style={{ color: '#fff' }}>Final Course Details</span>} bordered={false} className='cardStyle'>
                                            {profileDetails.visaDesk && profileDetails.visaDesk.selectedCourse ? (
                                                <Descriptions
                                                    column={1}
                                                    size="small"
                                                    bordered={false}
                                                    colon={false}
                                                    layout="horizontal"
                                                >
                                                    {/* Primary Details */}
                                                    {/* <Descriptions.Item label={<span style={styles.label}>Passport Number</span>}>
                                                        <span style={{ fontWeight: 600 }}>{profileDetails.visaDesk.passportNo}</span>
                                                    </Descriptions.Item> */}

                                                    <Descriptions.Item label={<span style={styles.label}>Final University</span>}>
                                                        <div style={{ fontWeight: 600, color: '#262626' }}>
                                                            {profileDetails.visaDesk.selectedCourse.universityInstitutionName}
                                                        </div>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<span style={styles.label}>Final Course</span>}>
                                                        <div style={{ color: '#1890ff', fontWeight: 500 }}>
                                                            {profileDetails.visaDesk.selectedCourse.courseName}
                                                        </div>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<span style={styles.label}>Institute Student ID</span>}>
                                                        <Tag color="blue">{profileDetails.visaDesk.selectedCourse.instituteStudentId}</Tag>
                                                    </Descriptions.Item>

                                                    {/* Channel Partner Specific Details */}
                                                    {showChannelPartner && (
                                                        <>
                                                            <Descriptions.Item label={<span style={styles.label}>Tuition Fees</span>}>
                                                                <span style={{ color: '#52c41a', fontWeight: 'bold' }}>
                                                                    {profileDetails.visaDesk.selectedCourse.tutionFee}
                                                                </span>
                                                            </Descriptions.Item>

                                                            <Descriptions.Item label={<span style={styles.label}>Vendor</span>}>
                                                                {profileDetails.visaDesk.selectedCourse.vendorName}
                                                            </Descriptions.Item>

                                                            <Descriptions.Item label={<span style={styles.label}>University Partnership</span>}>
                                                                <Tag>{profileDetails.visaDesk.selectedCourse.universityPartnership}</Tag>
                                                            </Descriptions.Item>

                                                            <Descriptions.Item label={<span style={styles.label}>Channel Partner</span>}>
                                                                <Badge
                                                                    status={profileDetails.visaDesk.channelPartnerName ? "success" : "default"}
                                                                    text={profileDetails.visaDesk.channelPartnerName ? profileDetails.visaDesk.channelPartnerName : "NA"}
                                                                />
                                                            </Descriptions.Item>
                                                        </>
                                                    )}
                                                </Descriptions>
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '20px', color: '#bfbfbf' }}>
                                                    <Icon type="info-circle" style={{ marginRight: 4 }} /> No Course Details Selected
                                                </div>
                                            )}
                                        </Card>
                                    </Col>
                                    {/* Visa Status Details */}
                                    <Col span={12}>
                                        {/* Visa Details Table */}
                                        <Card title={<span style={{ color: '#fff' }}>Visa Details</span>} bordered={false} className='cardStyle'>
                                            {profileDetails.visaDesk && profileDetails.visaDesk.selectedCourse ? (
                                                <Descriptions
                                                    column={1}
                                                    size="small"
                                                    bordered={false}
                                                    colon={false}
                                                    layout="horizontal"
                                                >
                                                    <Descriptions.Item label={<span style={styles.label}>Submission Date</span>}>
                                                        <span style={{ fontWeight: 500 }}>
                                                            {profileDetails.visaDesk.submissionDate ? moment(profileDetails.visaDesk.submissionDate).format('DD MMM YYYY') : 'N/A'}
                                                        </span>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<span style={styles.label}>Ref. Number</span>}>
                                                        <Tag color="geekblue" style={{ fontWeight: 'bold' }}>
                                                            {profileDetails.visaDesk.fileNo ? profileDetails.visaDesk.fileNo : 'N/A'}
                                                        </Tag>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<span style={styles.label}>Visa Status</span>}>
                                                        <Tag color={profileDetails.visaDesk.visaStatus === 'Approved' ? 'green' : 'orange'}>
                                                            {profileDetails.visaDesk.visaStatus ? profileDetails.visaDesk.visaStatus : 'Pending'}
                                                        </Tag>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<span style={styles.label}>Approval Date</span>}>
                                                        {profileDetails.visaDesk.visaApprovalDate ? moment(profileDetails.visaDesk.visaApprovalDate).format('DD MMM YYYY') : 'N/A'}
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<span style={styles.label}>Documents</span>}>
                                                        <Badge
                                                            status={profileDetails.visaDesk.documentsUploaded === 'Yes' ? "success" : "warning"}
                                                            text={profileDetails.visaDesk.documentsUploaded}
                                                        />
                                                    </Descriptions.Item>

                                                    <Descriptions.Item label={<span style={styles.label}>Expected Arrival</span>}>
                                                        <div style={{ color: '#1890ff', fontWeight: 600 }}>
                                                            <Icon type="rocket" style={{ marginRight: 4 }} />
                                                            {profileDetails.visaDesk.arrivalDate ? moment(profileDetails.visaDesk.arrivalDate).format('DD MMM YYYY') : 'N/A'}
                                                        </div>
                                                    </Descriptions.Item>
                                                </Descriptions>
                                            ) : (
                                                <div style={{ textAlign: 'center', padding: '20px', color: '#bfbfbf' }}>
                                                    <Icon type="info-circle" style={{ marginRight: 4 }} /> No Visa Information Found
                                                </div>
                                            )}
                                        </Card>
                                    </Col>

                                </Row>
                            </Card>

                            {/* Claim Desk */}
                            <Card title={<div style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", width: "100%" }}><span style={{ color: '#fff', }}>Claim Information </span><RightsWrapper myRight={"ClaimDesk.view"}><a
                                href={`/desk/getClaim?id=${this.state.studentId}`}
                                target="_blank"
                                style={{
                                    // backgroundColor: "transparent",
                                    // border: "1px solid white", // White border
                                    color: "#fff", // White text
                                    position: "absolute",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textDecoration: "underline",
                                    fontSize: "12px",
                                    right: 0, // Pushes button to the right
                                }}>Edit</a></RightsWrapper></div>} className='mainCardStyle'>
                                <Row gutter={16}>
                                    <Col span={12}>
                                        <Card title={<span style={{ color: '#fff' }}>Consultancy Fee</span>} bordered={false} className='cardStyle'>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0' }}>
                                                            <th style={styles.th}>Date</th>
                                                            <th style={styles.th}>Particulars / Ref</th>
                                                            <th style={styles.th}>Debit</th>
                                                            <th style={styles.th}>Credit</th>
                                                            <th style={styles.th}>Balance</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {profileDetails && profileDetails.accountPaymentDetails ? (
                                                            <>
                                                                {/* 1. Initial Consultancy Fee Entry */}
                                                                {/* 1. Initial Consultancy Fee Entry */}
                                                                <tr style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                                    <td style={styles.td}>
                                                                        {profileDetails.moveDeskDate && profileDetails.moveDeskDate.moveToRegistrationDesk
                                                                            ? moment(profileDetails.moveDeskDate.moveToRegistrationDesk).format(dateFormat)
                                                                            : 'N/A'}
                                                                    </td>

                                                                    <td style={styles.td}>
                                                                        <div style={{ fontWeight: 600 }}>Consultancy Fee</div>
                                                                        <small style={{ color: '#bfbfbf' }}>Initial Charge</small>
                                                                    </td>

                                                                    <td style={styles.td}>0</td>

                                                                    <td style={styles.td}>0</td>

                                                                    <td style={styles.td}>
                                                                        <Tag color="blue" style={{ fontWeight: 'bold' }}>
                                                                            0
                                                                        </Tag>
                                                                    </td>
                                                                </tr>

                                                                {/* 2. Payment History Entries */}
                                                                {profileDetails.accountPaymentDetails.length > 0 ? (
                                                                    profileDetails.accountPaymentDetails.map((payment, index) => (
                                                                        <tr key={index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                                            <td style={styles.td}>
                                                                                {moment(payment.dateOfReciept).format(dateFormat)}
                                                                            </td>
                                                                            <td style={styles.td}>
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <div style={{ marginRight: '8px' }}>
                                                                                        <div style={{ fontSize: '13px', fontWeight: 500 }}>{payment.paymentType}</div>
                                                                                        <div style={{ fontSize: '11px', color: '#8c8c8c' }}>
                                                                                            Receipt: <a onClick={() => this.showPaymentDrawer(payment.receipt)} style={{ cursor: 'pointer' }}>{payment.receipt}</a>
                                                                                        </div>
                                                                                    </div>
                                                                                    {payment.discountFile && payment.discountFile.length > 0 && (
                                                                                        <Tooltip title="Download Discount Proof">
                                                                                            <a
                                                                                                href={`${MEDIA_URL}${payment.discountFile[0].url}`}
                                                                                                target="_blank"
                                                                                                rel="noopener noreferrer"
                                                                                                style={{ color: '#1890ff' }}
                                                                                            >
                                                                                                <Icon type="download" style={{ fontSize: '12px' }} />
                                                                                            </a>
                                                                                        </Tooltip>
                                                                                    )}
                                                                                </div>
                                                                                {payment.remarks && (
                                                                                    <div style={{ fontSize: '10px', color: '#bfbfbf', fontStyle: 'italic' }}>
                                                                                        Note: {payment.remarks}
                                                                                    </div>
                                                                                )}
                                                                            </td>
                                                                            <td style={styles.td}>-</td>
                                                                            <td style={styles.td}>
                                                                                <span style={{ color: '#52c41a', fontWeight: 600 }}>
                                                                                    +{payment.paid}
                                                                                </span>
                                                                            </td>
                                                                            <td style={styles.td}>
                                                                                <Tag color={payment.balance <= 0 ? 'green' : 'blue'} style={{ fontWeight: 'bold' }}>
                                                                                    {payment.balance}
                                                                                </Tag>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    /* Fallback if list exists but is empty */
                                                                    <tr>
                                                                        <td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#bfbfbf' }}>
                                                                            {profileDetails.registrationDesk && profileDetails.registrationDesk.mode
                                                                                ? `Payment Mode: ${profileDetails.registrationDesk.mode}`
                                                                                : 'No payment transactions found'}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" style={{ padding: '20px', textAlign: 'center', color: '#bfbfbf' }}>
                                                                    <Icon type="loading" spin style={{ marginRight: 8 }} /> Loading Ledger Details...
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </Card>
                                    </Col>
                                    {claimDeskRights && !claimDeskRights.viewByBranch && (
                                        <Col span={12}>
                                            <Card
                                                title={<span style={{ color: "#fff" }}>Commission Details</span>}
                                                bordered={false}
                                                className="cardStyle"
                                            >
                                                {profileDetails && profileDetails.nextInvoiceGenerationDates ? (
                                                    <div style={{ overflowX: 'auto' }}>
                                                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                            <thead>
                                                                <tr style={{ background: '#fafafa', borderBottom: '2px solid #f0f0f0' }}>
                                                                    <th style={styles.th}>Term</th>
                                                                    <th style={styles.th}>Invoice Info</th>
                                                                    <th style={styles.th}>Debit</th>
                                                                    <th style={styles.th}>Credit</th>
                                                                    <th style={styles.th}>Balance</th>
                                                                    <th style={styles.th}>Status</th>
                                                                    <th style={styles.th}>Due Date</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {profileDetails.nextInvoiceGenerationDates.map((invoice, index) => {
                                                                    // 1. Safe Invoice Lookup
                                                                    var generatedInvoices = (profileDetails && profileDetails.generatedInvoices) ? profileDetails.generatedInvoices : [];

                                                                    var matchingInvs = generatedInvoices.filter(function (inv) {
                                                                        return inv.invoiceNumber === invoice.invoiceGeneratedNumber;
                                                                    });
                                                                    var foundInvoice = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : null;

                                                                    var printInvoice = null;
                                                                    var commissionTotal = 0;
                                                                    var currency = "";
                                                                    var status = invoice.invoiceStatus || "Pending";

                                                                    var getStatusWeight = (s) => {
                                                                        const st = (s || '').toLowerCase().trim();
                                                                        if (['cleared', 'paid by uni', 'completed'].includes(st)) return 4;
                                                                        if (st === 'approved by uni') return 3;
                                                                        if (st === 'submitted to uni') return 2;
                                                                        if (st === 'generated') return 1;
                                                                        return 0;
                                                                    };

                                                                    if (invoice && invoice.uploaded) {
                                                                        currency = invoice.currency || (foundInvoice && foundInvoice.currency) || "";
                                                                        commissionTotal = Number(invoice.commReceived || 0);
                                                                        status = invoice.invoiceStatus || "NA";
                                                                    } else if (foundInvoice && foundInvoice.invoices && foundInvoice.invoices.length > 0) {
                                                                        printInvoice = foundInvoice.invoices.find(function (invv) {
                                                                            return String(invv.invoiceGeneratedRecordId) === String(invoice._id);
                                                                        });
                                                                        commissionTotal = (printInvoice && printInvoice.commissionTotal) ? printInvoice.commissionTotal : 0;
                                                                        currency = (printInvoice && printInvoice.currency) ? printInvoice.currency : "";

                                                                        const dbStatus = status;
                                                                        const genStatus = foundInvoice.invoiceStatus || "Pending";
                                                                        const dbWeight = getStatusWeight(dbStatus);
                                                                        const genWeight = getStatusWeight(genStatus);
                                                                        status = dbWeight >= genWeight ? dbStatus : genStatus;
                                                                    }

                                                                    var isCleared = (status === "Paid By Uni" || status === "Cleared" || status === "Paid by Uni");

                                                                    var dueDate = (foundInvoice && foundInvoice.invoiceDueDate && !isCleared)
                                                                        ? moment(foundInvoice.invoiceDueDate).format(dateFormat)
                                                                        : null;

                                                                    return (
                                                                        <tr key={invoice._id || index} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                                            {/* Term */}
                                                                            <td style={styles.td}>
                                                                                <Badge count={invoice.invoiceNo} style={{ backgroundColor: '#1890ff' }} />
                                                                            </td>

                                                                            {/* Invoice Info */}
                                                                            <td style={styles.td}>
                                                                                <div style={{ fontWeight: 600 }}>
                                                                                    {invoice.uploaded ? invoice.cpInvoiceNumber : (invoice.invoiceGeneratedNumber || "NA")}
                                                                                </div>
                                                                                <small style={{ color: '#8c8c8c' }}>
                                                                                    Gen: {invoice.generationDate ? moment(invoice.generationDate).format(dateFormat) : "NA"}
                                                                                </small>
                                                                            </td>

                                                                            {/* Debit */}
                                                                            <td style={styles.td}>{formatAmount(commissionTotal, currency)}</td>

                                                                            {/* Credit */}
                                                                            <td style={styles.td}>
                                                                                <span style={{ color: isCleared ? '#52c41a' : 'inherit' }}>
                                                                                    {isCleared ? formatAmount(commissionTotal, currency) : formatAmount(0, currency)}
                                                                                </span>
                                                                            </td>

                                                                            {/* Balance */}
                                                                            <td style={styles.td}>
                                                                                <b style={{ color: isCleared ? '#bfbfbf' : '#f5222d' }}>
                                                                                    {isCleared ? formatAmount(0, currency) : formatAmount(commissionTotal, currency)}
                                                                                </b>
                                                                            </td>

                                                                            {/* Invoice Status */}
                                                                            <td style={styles.td}>
                                                                                <Tag color={isCleared ? 'green' : 'blue'} style={{ borderRadius: '10px' }}>
                                                                                    {status}
                                                                                </Tag>
                                                                            </td>

                                                                            {/* Due Date */}
                                                                            <td style={styles.td}>
                                                                                {dueDate ? (
                                                                                    <span style={{ color: '#f5222d', fontSize: '11px', fontWeight: 600 }}>
                                                                                        <Icon type="calendar" style={{ marginRight: 4 }} />
                                                                                        {dueDate}
                                                                                    </span>
                                                                                ) : "-"}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div style={{ textAlign: 'center', padding: '30px', color: '#bfbfbf' }}>
                                                        <Icon type="inbox" style={{ fontSize: '24px' }} /><br />
                                                        No commission dates scheduled
                                                    </div>
                                                )}
                                            </Card>
                                        </Col>

                                    )}



                                </Row>
                            </Card>

                        </div>
                    }
                </Card>
            </PageHeaderWrapper>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProfileDetails)
